module.exports = __webpack_public_path__ + "img/07-img@3x.eb1b3458.png";